import * as React from 'react';
import { observer, inject } from "mobx-react";
import { Button, TextField } from '@material-ui/core';

// =====================================
// STORES
import { ILoginStore } from '../../store/loginStore';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';
import { Loader } from '../Layout/Loader';
import { ErrorMessage } from '../Layout/ErrorMessage';
import Organization from './Organization';

interface ILogin {
    loginStore?: ILoginStore
}

@inject((allStores: any) => ({
    loginStore: allStores.store.loginStore as ILoginStore
}))

@observer
export default class Register extends React.Component<ILogin, any> {

    componentDidMount() {
        this.props.loginStore.init("register");
    }

    componentWillUnmount() {
        this.props.loginStore.reset();
        this.props.loginStore.onSignOut();
    }

    render() {
        return (
            <div className="login-container">
                <Header
                    title="Registrujte se"
                    isBackButtonVisible={true}
                    url={'/'} />

                <div id="recaptcha-container"></div>

                {!this.props.loginStore.isLoading ?
                    <>
                        <h2 className="welcome-title">Registrujte se sa brojem telefona</h2>
                        <div className="container">

                            {this.props.loginStore.isPhoneNumberFormVisible
                                ? <div>
                                    <form noValidate autoComplete="off" className="login-form">
                                        <TextField
                                            id="phone-number"
                                            label="Broj telefona (06x-xxx-xxxx)"
                                            type="number"
                                            name="phoneNumber"
                                            className="phone-number-input"
                                            value={this.props.loginStore.phoneNumber}
                                            onChange={this.props.loginStore.onHandleChangeInput} />
                                        <ErrorMessage>
                                            {this.props.loginStore.phoneNumberMessage}
                                        </ErrorMessage>
                                        <Button
                                            variant="contained"
                                            color="default"
                                            size="small"
                                            className="btn-login"
                                            onClick={this.props.loginStore.onSignInWithPhoneNumber}
                                        > Verifikujte vaš broj
                                        </Button>
                                    </form>
                                </div> : null
                            }

                            {this.props.loginStore.isCodeFormVisible
                                ? <div>
                                    <form noValidate autoComplete="off" className="login-form">
                                        <TextField
                                            id="code-number"
                                            label="Verifikacioni kod"
                                            type="number"
                                            name="code"
                                            className="phone-number-input"
                                            value={this.props.loginStore.code}
                                            onChange={this.props.loginStore.onHandleChangeInput} />
                                        <ErrorMessage>
                                            {this.props.loginStore.codeMessage}
                                        </ErrorMessage>
                                        <Button
                                            variant="contained"
                                            color="default"
                                            size="small"
                                            className="btn-login"
                                            onClick={this.props.loginStore.onSubmitCode}
                                        > Ulogujte se
                                        </Button>
                                    </form>
                                </div> : null
                            }

                            {this.props.loginStore.isRegistrationFormVisible
                                ? <div>
                                    <form noValidate autoComplete="off" className="login-form">
                                        <TextField
                                            id="phone-number"
                                            label="Broj telefona (06x-xxx-xxxx)"
                                            disabled
                                            name="phoneNumber"
                                            className="phone-number-input"
                                            value={this.props.loginStore.phoneNumber}
                                            onChange={this.props.loginStore.onHandleChangeInput} />
                                        <TextField
                                            id="fullName"
                                            label="Ime i prezime"
                                            name="fullName"
                                            className="phone-number-input"
                                            value={this.props.loginStore.fullName}
                                            onChange={this.props.loginStore.onHandleChangeInput} />
                                        <ErrorMessage>
                                            {this.props.loginStore.fullNameMessage}
                                        </ErrorMessage>
                                        <Organization />
                                    </form>
                                </div> : null
                            }
                        </div>
                    </> : <Loader />}
            </div>
        );
    }
}